import React from 'react';
import { T, fontBody, textareaStyle } from '../tokens';

export default function ReplyMessageField({
  label = 'Message',
  value,
  onChange,
  error,
  placeholder = 'Use {{name}} for contact name',
  minHeight = 160,
}) {
  return (
    <div>
      <div style={{ fontFamily: fontBody, fontSize: 12, fontWeight: 600, color: T.slate, marginBottom: 6 }}>{label}</div>
      <textarea
        style={{
          ...textareaStyle,
          minHeight,
          borderColor: error ? '#DC2626' : T.line,
        }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      <div style={{ fontFamily: fontBody, fontSize: 11, color: T.slateLight, marginTop: 6 }}>
        Variables: {'{{name}}'}
      </div>
      {error && (
        <div style={{ fontFamily: fontBody, fontSize: 11, color: '#DC2626', marginTop: 6 }}>{error}</div>
      )}
    </div>
  );
}
